import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppGuard } from './app.guard';
import { LoginComponent } from './components/login/login.component';
import { CotizacionComponent } from './components/cotizacion/cotizacion.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';
import { ViajeVistaOperadorComponent } from './components/viaje-vista-operador/viaje-vista-operador.component'
import { InfoVentasDiariasComponent } from './components/info-ventas-diarias/info-ventas-diarias.component';
import { ClientesComponent } from '../app/componentes-clientes/clientes.component';

const appRoutes: Routes = [
	{
		path: '',
		component: LoginComponent
    },
    {
		path: 'detalle-ventas-diarias',
		component: InfoVentasDiariasComponent
    },
    {
		path: 'confirmacion/:id',
		component: ConfirmacionComponent
    },
    {
		path: 'cotizacion/:id',
		component: CotizacionComponent
    },
    {
		path: 'viaje-vista-operador/:idViaje',
		component: ViajeVistaOperadorComponent
    },
		{
			path : 'clientes',
			loadChildren : 'app/componentes-clientes/clientes.module#ClientesModule',
			canActivate : [AppGuard]
		},
	{
		path : 'recursos-humanos',
		loadChildren : 'app/recursos-humanos/recursos-humanos.module#RecursosHumanosModule',
		canActivate : [AppGuard]
	},
	{
		path : 'agencia-externa',
		loadChildren : 'app/agencia-externa/agencia-externa.module#AgenciaExternaModule',
		canActivate : [AppGuard]
	},
	{
		path : 'ventas',
		loadChildren : 'app/ventas/ventas.module#VentasModule',
		canActivate : [AppGuard]
	},
	{
		path : 'finanzas',
		loadChildren : 'app/finanzas/finanzas.module#FinanzasModule',
		canActivate : [AppGuard]
	},
	{
		path : 'planeacion',
		loadChildren : 'app/planeacion/planeacion.module#PlaneacionModule',
		canActivate : [AppGuard]
	},
	{
		path : 'mantenimiento',
		loadChildren : 'app/mantenimiento/mantenimiento.module#MantenimientoModule',
		canActivate : [AppGuard]
    },
    {
		path : 'monitoreo',
		loadChildren : 'app/monitoreo/monitoreo.module#MantenimientoModule',
		canActivate : [AppGuard]
	},
	{
		path: '**',
		redirectTo : ''
	}
];

export const AppRouting:ModuleWithProviders = RouterModule.forRoot(appRoutes, {useHash:true});



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/app.routing.ts